import React from 'react';
// import './faqs.scss';
import Accordion from 'react-bootstrap/Accordion';

const faqs = [
  {
    question: "What is the Browser feature in TOMI, and how does it work?",
    answer: "TOMI includes an integrated private browser with a built-in VPN. It blocks ads, encrypts traffic, and ensures a secure, censorship-free browsing experience.",
  },
  {
    question: "How is my privacy protected?",
    answer: "Your traffic is routed through decentralized VPN nodes, preventing tracking, data collection, and regional restrictions. No logs are stored, ensuring complete anonymity.",
  },
  {
    question: "Can I access blocked websites?",
    answer: "Yes. TOMI’s built-in VPN allows you to bypass censorship and geo-restrictions, ensuring open internet access worldwide.",
  },
  {
    question: "Does it affect browsing speed?",
    answer: "No, it often improves speed by removing ads, trackers, and unnecessary scripts that slow down regular browsing.",
  },
  {
    question: "Do I need to install anything extra?",
    answer: "No. The VPN and ad blocker are integrated into the browser and work automatically without additional installations.",
  },
  {
    question: "How is this different from a regular VPN?",
    answer: "Unlike standard VPNs, TOMI offers decentralized VPN routing, built-in ad blocking, and seamless integration with Web3 services, providing a private and crypto-friendly browsing experience.",
  }
];

const Faqsbrowssecurly = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map((faq) => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer,
      },
    })),
  };

  return (
    <section className='faqsmainprnt'>
      <div className="postionfaqs">
        <img className='img-fluid' src="/assets/faqpositionimg.png" alt="FAQ Banner" />
      </div>
      <div className="custom-container">
        <div className="faqschldmain">
          <h2>FAQ</h2>
          <div className="faqscustumdesigine">
            <div className="accordion" id="accordionExample">
              {faqs.map((faq, index) => (
                <div className="accordion-item" key={index}>
                  <h3 className="accordion-header">
                    <button className={`accordion-button ${index !== 0 ? "collapsed" : ""}`} type="button" data-bs-toggle="collapse" data-bs-target={`#collapse${index}`} aria-expanded="false" aria-controls={`collapse${index}`}>
                      <div className="btninner">{faq.question}</div>
                    </button>
                  </h3>
                  <div id={`collapse${index}`} className={`accordion-collapse collapse ${index === 0 ? "show" : ""}`} data-bs-parent="#accordionExample">
                    <div className="accordion-body">
                      <div className="bodymain"><span>{faq.answer}</span></div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
    </section>
  );
};

export default Faqsbrowssecurly;